import { fetchAuthSession } from 'aws-amplify/auth';
import { loadRuntimeConfig } from '../config/runtime-config';

export const getQuickSightEmbedUrl = async (dashboardId: string): Promise<string> => {
  try {
    const config = await loadRuntimeConfig();
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    
    if (!token) {
      throw new Error('No authentication token available');
    }

    const response = await fetch(`${config.apiUrl}/api/quicksight/embed`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        dashboardId: dashboardId
      })
    });

    if (!response.ok) {
      throw new Error(`QuickSight API error: ${response.status}`);
    }

    const data = await response.json();
    return data.embedUrl;
  } catch (error) {
    console.error('Error getting QuickSight embed URL:', error);
    throw error;
  }
};

export const getQuickChatEmbedUrl = async (): Promise<string> => {
  try {
    const config = await loadRuntimeConfig();
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    
    if (!token) {
      throw new Error('No authentication token available');
    }

    const response = await fetch(`${config.apiUrl}/api/quickchat/embed`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({})
    });

    if (!response.ok) {
      throw new Error(`QuickChat API error: ${response.status}`);
    }

    const data = await response.json();
    return data.embedUrl;
  } catch (error) {
    console.error('Error getting QuickChat embed URL:', error);
    throw error;
  }
};
